import { render } from "./CrNavigationTop.vue?vue&type=template&id=317640be&scoped=true"
import script from "./CrNavigationTop.vue?vue&type=script&lang=js"
export * from "./CrNavigationTop.vue?vue&type=script&lang=js"

import "./CrNavigationTop.vue?vue&type=style&index=0&id=317640be&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317640be"]])

export default __exports__